import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import LockDesignerLanding from 'Vue/components/lockDesigner/components/views/LockDesignerLanding.vue';
import LockDesignerProducts from 'Vue/components/lockDesigner/components/views/LockDesignerProducts.vue';
import LockDesignerDoorType from 'Vue/components/lockDesigner/components/views/LockDesignerDoorType.vue';
import AccountLoginModal from 'Vue/components/lockDesigner/components/shared/Modals/AccountLoginModal.vue';
import AccountRegistrationModal from 'Vue/components/lockDesigner/components/shared/Modals/AccountRegistrationModal.vue';
import AccountForgotPasswordModal from 'Vue/components/lockDesigner/components/shared/Modals/AccountForgotPasswordModal.vue';
import AddToWishlistModal from 'Vue/components/lockDesigner/components/shared/Modals/AddToWishlistModal.vue';
import ShareModal from 'Vue/components/lockDesigner/components/shared/Modals/ShareModal.vue';
import AccountResetPasswordModal from 'Vue/components/lockDesigner/components/shared/Modals/AccountResetPasswordModal.vue';
import { lockDesignerStore } from 'Store/lockDesignerStore';
import WishlistLockDesigner from "Vue/components/lockDesigner/components/WishlistLockDesigner.vue";

// @ts-ignore
// @ts-ignore
const routes: Array<RouteRecordRaw> = [
    {
        path: '/lock-designer',
        name: 'Defaults',
        props: true,
        component: LockDesignerLanding,
        meta: {
            enterClass: 'animate__animated animate__fadeInLeft',
            leaveClass: 'animate__animated animate__fadeOutRight',
        },
        children: [
            {
                path: 'login',
                name: 'Login', // Add a name to the route
                component: AccountLoginModal,
                meta: {
                    loginModal: true, // Indicate that this route should open a modal
                    forwardingRoute: '/lock-designer/wishlist-add',
                    closeModal: false,
                    pathPrefix: '/lock-designer'
                },
            },
            {
                path: 'register',
                name: 'Register',
                component: AccountRegistrationModal,
                meta: {
                    registerModal: true, // Indicate that this route should open a modal
                    forwardingRoute: '/lock-designer/wishlist-add',
                    closeModal: false,
                    pathPrefix: '/lock-designer'
                },
            },
            {
                path: 'forgot-password',
                name: 'Forgot Password',
                component: AccountForgotPasswordModal,
                meta: {
                    forgotPasswordModal: true,
                    pathPrefix: '/lock-designer'
                },

            },
            {
                path: 'reset-password',
                name: 'Reset Password',
                component: AccountResetPasswordModal,
                props: true,
                meta: {
                    resetPasswordModal: true,
                    pathPrefix: '/lock-designer'
                },
            },
            {
                path: 'wishlist-add',
                name: 'Wishlist Add',
                component: AddToWishlistModal,
                meta: {
                    addToWishlistModal: true,
                    pathPrefix: '/lock-designer'
                },
            },
            {
                path: 'share',
                name: 'Share',
                component: ShareModal,
                meta: {
                    shareModal: true,
                    pathPrefix: '/lock-designer'
                },
            }
        ]
    },
    {
        path: '/lock-designer/Selections', // Alternate path
        redirect: '/lock-designer',
    },
    {
        path: '/wishlist',
        name: "Lock Designer Wish list",
        component: WishlistLockDesigner,
        children: [
            {
                path: 'login',
                name: 'Login Wishlist',
                component: AccountLoginModal,
                meta: {
                    loginModal: true,
                    forwardingRoute: '/wishlist',
                    closeModal: true,
                    pathPrefix: '/wishlist'
                },
            },
            {
                path: 'register',
                name: 'Register Wishlist',
                component: AccountRegistrationModal,
                meta: {
                    registerModal: true,
                    forwardingRoute: '/wishlist',
                    closeModal: true,
                    pathPrefix: '/wishlist'
                },
            },
            {
                path: 'forgot-password',
                name: 'Forgot Password Wishlist',
                component: AccountForgotPasswordModal,
                meta: {
                    forgotPasswordModal: true,
                    pathPrefix: '/wishlist'
                },

            },
            {
                path: 'reset-password',
                name: 'Reset Password Wishlist',
                component: AccountResetPasswordModal,
                props: true,
                meta: {
                    resetPasswordModal: true,
                    pathPrefix: '/wishlist'
                },
            },
        ]
    },
    {
        path: '/lock-designer/Selection',
        name: 'Selection',
        props: true,
        component: LockDesignerLanding,
        meta: {
            enterClass: 'animate__animated animate__fadeInLeft',
            leaveClass: 'animate__animated animate__fadeOutRight',
        },
    },
    {
        path: '/lock-designer/Product/:product',
        name: 'Product',
        props: true,
        component: LockDesignerProducts,
        meta: {
            enterClass: 'animate__animated animate__fadeInLeft',
            leaveClass: 'animate__animated animate__fadeOutRight',
        },
    },
    {
        path: '/lock-designer/DoorType',
        name: 'DoorType',
        props: true,
        component: LockDesignerDoorType,
        children: [
            {
                path: ':option',
                component: LockDesignerDoorType,
                meta: {
                    enterClass: 'animate__animated animate__fadeInRight',
                    leaveClass: 'animate__animated animate__fadeOutLeft',
                },
            },
        ],
        meta: {
            enterClass: 'animate__animated animate__fadeInRight',
            leaveClass: 'animate__animated animate__fadeOutLeft',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


router.beforeEach((to, from, next) => {
    //console.log(to, from, next);

    if (to.meta.loginModal) {
        lockDesignerStore.dispatch('openModal', { component: AccountLoginModal, props: { forwardingRoute: to.meta.forwardingRoute, closeModal: to.meta.closeModal, pathPrefix: to.meta.pathPrefix } });
        next(false);
    } else if(to.meta.registerModal) {
        lockDesignerStore.dispatch('openModal', { component: AccountRegistrationModal, props: { forwardingRoute: to.meta.forwardingRoute, closeModal: to.meta.closeModal, pathPrefix: to.meta.pathPrefix } });
        next(false);
    } else if(to.meta.forgotPasswordModal) {
        lockDesignerStore.dispatch('openModal', { component: AccountForgotPasswordModal, props: { pathPrefix: to.meta.pathPrefix } });
        next(false);
    } else if(to.meta.resetPasswordModal) {
        lockDesignerStore.dispatch('openModal', { component: AccountResetPasswordModal, props: { pathPrefix: to.meta.pathPrefix } });
        next(false);
    } else if(to.meta.addToWishlistModal) {
        lockDesignerStore.dispatch('openModal', { component: AddToWishlistModal });
        next(false);
    } else if(to.meta.shareModal) {
        lockDesignerStore.dispatch('openModal', { component: ShareModal });
        next(false);
    } else {
        next();
    }
});



export default router;
